import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowActions } from '@components/Modal/ModalWindowActions';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { FileUploadParams, useFileUpload } from '@hooks/useFileUpload';
import { IModalWindow } from '@hooks/useModalWindow';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { ArquivoModalBar } from './ArquivoModalBar';
import { ArquivoModalTable } from './ArquvioModalTable';

export type ArquivoModalProps<T = any, U = never> = FileUploadParams<T, U> & {
    modal: IModalWindow
    title: string
    accept: string
    buttonText: string
    multiple?: boolean
}

export function ArquivoModal<T = any, U = never>({ modal, title, accept, multiple, buttonText, onUpload, uploadFunction, onCollectAditionalParams }: ArquivoModalProps<T, U>) {
    const cls = useStyles();
    const fileUpload = useFileUpload<T, U>({
        onUpload,
        uploadFunction,
        onCollectAditionalParams
    });

    const handleEnter = React.useCallback(() => {
        fileUpload.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <ModalWindow
            modal={modal}
            disabled={fileUpload.isLoading}
            size="md"
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle title={title} />
            
            <ModalWindowContent>
                <ArquivoModalBar 
                    accept={accept}
                    multiple={multiple}
                    onFilesSelected={fileUpload.handleFilesSelected}
                />

                <TableWrapper className={cls.table}>
                    <ArquivoModalTable 
                        data={fileUpload.data}
                        isLoading={fileUpload.isLoading}
                    />
                </TableWrapper>
            </ModalWindowContent>

            <ModalWindowActions>
                <PrimaryButton 
                    onClick={fileUpload.handleConfirm}
                    disabled={!fileUpload.hasAwaitting}
                >{buttonText}</PrimaryButton>
            </ModalWindowActions>
        </ModalWindow>
    )
}

const useStyles = makeStyles(theme => ({
    table: {
        marginTop: theme.spacing(3)
    }
}));

